import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "./menu.css";

/* import imgDashboard from './svg/Dashboard.svg'; */
// import { startLogout } from '../../redux/actions/auth';
import { getMenuOptions } from "../../helpers/menu";
import { useMediaQuery } from "@mui/material";
/* import { ChartPie, ChevronDown, ChevronRight } from "lucide-react";
 */
export const Menu = ({ stateMenu, setOpenMenu }) => {
  const { id: idPro } = useSelector((state) => state.general.info);
  const { access, perfil } = useSelector((state) => state.auth);
  const [openSubMenuDashboard, setOpenSubMenuDashboard] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);

  let location = useLocation();
  // const dispatch = useDispatch();

  const pathSelect = (path) => {
    const newPaths = location.pathname.split("/");
    if (newPaths[1] === path) return true;
    return false;
  };

  const pathSelectSubs = (path) => {
    if (location.pathname === path) return true;
    return false;
  };

  // const handleLogout = () => {
  //     dispatch(startLogout());
  // }

  useEffect(() => {
    const currentMenu = getMenuOptions(access, perfil, idPro);
    setMenuOptions(currentMenu);
  }, [access, perfil, idPro]);

  return (
    <nav
      className={`
            nav flex-column menu-box     
            ${stateMenu === "all_open" && "menu-box-open"}
            ${stateMenu === "medium_open" && "menu-box-medium_open"}
            ${stateMenu === "closed" && "menu-box-closed"}
            absolute md:relative z-50 
            space-y-3 overflow-y-auto px-2 py-2 mt-2
        `}
    >
      {menuOptions
        ?.filter((m) => m.show)
        .map((it) => (
          <MenuItem
            key={it.id}
            item={it}
            pathSelect={pathSelect}
            setOpenSubMenuDashboard={setOpenSubMenuDashboard}
            openSubMenuDashboard={openSubMenuDashboard}
            pathSelectSubs={pathSelectSubs}
            access={access}
            setOpenMenu={setOpenMenu}
          />
        ))}
    </nav>
  );
};

const MenuItem = ({
  item,
  pathSelect,
  setOpenSubMenuDashboard,
  openSubMenuDashboard,
  pathSelectSubs,
  access,
  setOpenMenu,
}) => {
  const { path, path_select, icon, iconActive, title } = item;
  const isMobile = useMediaQuery("(max-width:768px)");

  if (item.title === "Dashboard") {
    return (
      <>
        <Link
          to="/dashboard"
          className={`
          group flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition-colors  
          ${pathSelect(path_select) ? "bg-[#f8ebfc] text-[--primary-color] hover:text-[--primary-color] font-semibold" : "hover:text-[#726777] hover:bg-[#f5f2f6]"}
        `}
          aria-current="page"
          onClick={() => {
            setOpenSubMenuDashboard(!openSubMenuDashboard);

            if (isMobile) {
              setOpenMenu(false);
            }
          }}
        >
          {/* {openSubMenuDashboard ? (
            <ChevronDown
              size={16}
              color="#645e64"
              strokeWidth={2.5}
              className="p-icon-sub-menu"
            />
          ) : (
            <ChevronRight
              size={16}
              color="#645e64"
              strokeWidth={2.5}
              className="p-icon-sub-menu"
            />
          )} */}
          {pathSelect(path_select) ? iconActive : icon}
          <span>Dashboard</span>
        </Link>

        {openSubMenuDashboard && (
          <div className="submenus">
            <Link
              to="/dashboard/pptos"
              className={`nav-link-sub active d-flex align-items-center menu-box-dashboard ${pathSelectSubs("/dashboard/pptos") && "ActiveMenu"}`}
              onClick={() => {
                if (isMobile) {
                  setOpenMenu(false);
                }
              }}
            >
              <i className="bi bi-graph-up-arrow"></i>
              <span className="ms-2">Presupuestos</span>
            </Link>
            <Link
              to="/dashboard/ventas"
              className={`nav-link-sub active d-flex align-items-center menu-box-dashboard ${pathSelectSubs("/dashboard/ventas") && "ActiveMenu"}`}
              onClick={() => {
                if (isMobile) {
                  setOpenMenu(false);
                }
              }}
            >
              <i className="bi bi-graph-up"></i>
              <span className="ms-2">Ventas</span>
            </Link>

            {access.a11 && (
              <Link
                to="/dashboard/gastos"
                className={`nav-link-sub active d-flex align-items-center menu-box-dashboard ${pathSelectSubs("/dashboard/gastos") && "ActiveMenu"}`}
                onClick={() => {
                  if (isMobile) {
                    setOpenMenu(false);
                  }
                }}
              >
                <i className="bi bi-graph-down"></i>
                <span className="ms-2">Gastos</span>
              </Link>
            )}
          </div>
        )}
      </>
    );
  } else {
    return (
      <Link
        to={path}
        className={`
          group flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition-colors  
          ${pathSelect(path_select) ? "bg-[#f8ebfc] text-[--primary-color] hover:text-[--primary-color] font-semibold" : "hover:text-[#726777] hover:bg-[#f5f2f6]"}
        `}
        onClick={() => {
          if (isMobile) {
            setOpenMenu(false);
          }
        }}
      >
        {pathSelect(path_select) ? iconActive : icon}
        <span className="tracking-wide">{title}</span>
      </Link>
    );
  }
};
